<template>
  <div>
    <modal
        :width="500"
        height="auto"
        name="m-delete-zone-auction"
    >
      <div class="modal-dialog abtg-modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title abtg__modal-title" >CANCELLA QUESTA ZONA ASTE</h5>

            <div class="tools">
              <div class="abtg__close-button"><a @click="closeModal()"><i
                  class="fas fa-times"></i></a></div>
            </div>
          </div>

          <div class="modal-body">
            <h3>Sei sicuro di voler eliminare questa zona aste?</h3>
          </div>
          <div class="modal-footer">

            <button
                @click="closeModal()"
                type="submit"
                class="btn btn-default abtg__btn-star shadow-none abtg__btn-tool">
              No, ci ho ripensato
            </button>

            <button
                @click="deleteResource()"
                type="submit" class="btn btn-default  abtg__btn-third shadow-none abtg__btn-tool">
              Elimina
            </button>
            <div style="margin-bottom:30px;height:30px;">&nbsp;</div>
          </div>
          <div class="modal-body">
            <div class="container">


            </div>
          </div>

        </div>
      </div>
    </modal>
  </div>

</template>
<script>
export default {
  props: ['content'],
  data() {
    return {
    }
  },

  methods: {
    closeModal() {
      this.$emit('closeModal','m-delete-zone-auction');
    },

    deleteResource()
    {
      this.$emit('deleteResourceZoneAuction');
      this.closeModal();
    }
  }
}
</script>
